import ChartFrame from './ChartFrame'
import WorldCanvas, { place } from './WorldCanvas'
import type { IpDetails } from '@shared/api'
import styles from './WorldPlot.module.css'

interface LocationMapProps {
    self: IpDetails | undefined
}

/**
 * The visitor's own position on the same self-hosted world map the leak test
 * uses. This replaces the Google Maps embed that used to sit on the home page:
 * that embed shipped an API key in the bundle, showed a blank box to every
 * visitor in mainland China, and did nothing this does not. Here nothing is
 * fetched at all.
 */
export default function LocationMap({ self }: LocationMapProps) {
    const you = place(self?.location)
    const place_ = [self?.cityName, self?.region, self?.countryName].filter(Boolean).join(', ')

    const table = (
        <table>
            <thead>
                <tr><th scope="col">Place</th><th scope="col">Coordinates</th></tr>
            </thead>
            <tbody>
                <tr>
                    <td>{place_ || '—'}</td>
                    <td>
                        {self?.location?.latitude !== undefined && self.location.longitude !== undefined
                            ? `${self.location.latitude.toFixed(2)}, ${self.location.longitude.toFixed(2)}`
                            : 'not located'}
                    </td>
                </tr>
            </tbody>
        </table>
    )

    return (
        <ChartFrame
            title="Your location"
            note="Derived from a geoip database and city-level at best — it is where the network places you, not a precise position."
            aside={place_ || undefined}
            table={table}
        >
            {you ? (
                <WorldCanvas label={`World map showing your location${place_ ? ` in ${place_}` : ''}`}>
                    <circle className={styles.you} cx={you.x} cy={you.y} r={9}>
                        <title>You{place_ ? ` · ${place_}` : ''}</title>
                    </circle>
                </WorldCanvas>
            ) : (
                <p className={styles.unplaced}>Your location could not be determined from your address.</p>
            )}
        </ChartFrame>
    )
}
